export function SidebarSkeleton(props: { children: React.ReactNode }) {
	return (
		<div className="w-[clamp(14rem,30%,20rem)] hidden desktop-nav:block bg-surface-default shadow-md relative">
			<div className="absolute inset-0">{props.children}</div>
		</div>
	);
}


